export default __webpack_public_path__ + "static/invisiV-s-e2ab833b0344f9e7bbce9148deb11fde.mp4";